module.exports = __webpack_public_path__ + "static/media/noto-sans.63ebcf41.ttf";